import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumb as BaseBreadcrumb, Box, Text } from "native-base";
import BreadcrumbLink from "../atoms/BreadcrumbLink";
const Breadcrumb = ({ children, separator }) => (_jsx(Box, Object.assign({ maxWidth: "full" }, { children: _jsx(BaseBreadcrumb, Object.assign({ flexWrap: "wrap", separator: separator !== null && separator !== void 0 ? separator : _jsx(Text, Object.assign({ color: "gray.500" }, { children: "/" })) }, { children: children })) })));
Breadcrumb.Item = BaseBreadcrumb.Item;
Breadcrumb.Link = BreadcrumbLink;
Breadcrumb.Text = BaseBreadcrumb.Text; //TODO: wrap into <Text>
Breadcrumb.Icon = BaseBreadcrumb.Icon;
export default Breadcrumb;
